import styled from 'styled-components';
import {dFlex, alignCenter} from '../../../../../../globalVariables/GlobalFlex';
import {GRAY, LIGHT_GRAY3, WHITE, HOVER_BLUE} from '../../../../../../globalVariables/GlobalVariables';

export const statusFilterContainer = styled.div`
    ${dFlex}
    gap: 10px;
    ${alignCenter}
    position: relative;
`;

export const filterIcon = styled.span`
    margin-inline-end: 8px;
    color: ${GRAY};
`;

export const filterButton = styled.button`
    padding: 8px 12px;
    border: 1px solid ${LIGHT_GRAY3};
    border-radius: 6px;
    background: ${WHITE};
    min-width: 120px;
    cursor: pointer;
    font-size: 14px;
    
    &:hover {
        border-color: ${HOVER_BLUE};
    }
    
    &:focus {
        outline: none;
        border-color: ${HOVER_BLUE};
    }
`;
